import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import '../CSS/PowerBI.css';

const PowerBI = () => {
    const [access_token, setAccessToken] = useState('');
    
    useEffect(() => {
        // Fetch reports data from your server
        fetch('/api/hello')
            .then((response) => response.json())
            .then((data) => {
                setAccessToken(data.accessToken);
            })
            .catch((error) => {
                console.error('Error fetching reports data:', error);
            });
    }, []);

    

    return (
        <div className="power-bi">
            <div className="reports-hero powerbi-hero">
  <div className="reports-hero-content">
    <p className="reports-eyebrow">Orion Analytics</p>

    <h1 className="stats-header">FDA FOIA Logs</h1>

    <p className="reports-hero-description">
      Near real-time statistics and charts powered by data sourced from INA’s
      proprietary database.
    </p>

    <p className="reports-hero-description">
      Examine FDA FOIA request data to identify activist information requirements, 
      monitor collection trends, and assess patterns that may provide insight into 
      campaign priorities, emerging areas of interest, and potential future activity.
    </p>
  </div>

  <div className="reports-hero-count">
    <span>Live</span>
    <p>Analytics</p>
  </div>
</div>

            <style>
                {`
                    iframe {
                        border: none;
                    }
                `}
            </style>
          
        {access_token && (
            <PowerBIEmbed
                embedConfig={{
                    type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                    id: 'cbaa348b-d775-46f5-8e8d-ba02fc987eb9',
                    embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=cbaa348b-d775-46f5-8e8d-ba02fc987eb9&groupId=8462ee1f-e8db-4f03-bba9-021eabab566f&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d",',
                    accessToken: access_token,
                    tokenType: models.TokenType.Aad, // Use models.TokenType.Aad for SaaS embed
                    //pageName : 'ReportSectionb9f969caf36ee4e18e90',
                    settings: {
                        panes: {
                            filters: {
                                expanded: false,
                                visible: false,
                            }
                        },
                        layoutType: models.LayoutType.Single,
                        navContentPaneEnabled: false,
                        background: models.BackgroundType.Transparent,
                        
                    }
                }}

                eventHandlers={
                    new Map([
                        ['loaded', function () { console.log('Report loaded'); }],
                        ['rendered', function () { console.log('Report rendered'); }],
                        ['error', function (event) { console.log(event.detail); }],
                        ['visualClicked', () => console.log('visual clicked')],
                        ['pageChanged', (event) => console.log(event)],
                    ])
                }

                cssClassName={"reportClass"}

                getEmbeddedComponent={(embeddedReport) => {
                    window.report = embeddedReport;
                }}
            />
            )}
        </div>
    );

}

export default PowerBI;